module.exports = new __parcel__URL__("storm-darkmode.c1e44c54.svg").toString();